<template>
    <v-content>
        <v-app>
             <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs8>
                        <v-form ref="form" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs4>
                                    <v-select v-model="form.channel" :items="channelOptions" label="Channels"></v-select>
                                    <v-select @change="addressOnChange" :items="addresses" item-text="address_name" label="Addresses"></v-select>
                                    <v-text-field v-model="form.firstName" label="First Name" :rules="rules" required></v-text-field>
                                    <v-text-field v-model="form.surname" label="Surname" :rules="rules" required></v-text-field>
                                    <v-text-field v-model="form.address1" label="Address 1" :rules="rules" required></v-text-field>
                                    <v-text-field v-model="form.address2" label="Address 2"></v-text-field>
                                </v-flex>
                                <v-flex xs1></v-flex>
                                <v-flex xs4>
                                    <v-text-field v-model="form.city" label="City" :rules="rules" required></v-text-field>
                                    <v-text-field v-model="form.postcode" label="Postcode" :rules="rules" required></v-text-field>
                                    <v-select v-model="form.country" :items="countryOptions" :rules="rules" label="Please select a country"></v-select>
                                    <v-text-field v-model="form.amount" label="Amount" :rules="rules" required></v-text-field>
                                    <v-autocomplete v-model="form.currency" :items="sortedCurrencies" label="Please select a currency"></v-autocomplete>
                                    <v-text-field v-model="form.registrationId" label="Registration ID"></v-text-field>
                                    <v-flex xs12 row class="text-xs-right pa-0" id="form-btns">
                                        <v-btn  @click="onSubmit" color="primary">Submit</v-btn>
                                        <v-btn @click="onReset" class="mr-0" color="error">Reset</v-btn>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-flex>
                    <v-flex xs4>
                        <iframe id="threeDsContainer" frameBorder=0 scrolling="no"></iframe>
                    </v-flex>
                </v-layout>
             </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';

    export default {
        data () {
            return {
                rules: [
                    v => !!v || 'Required field'
                ],
                form: {
                    firstName: null,
                    surname: null,
                    address1: null,
                    address2: null,
                    city: null,
                    postcode: null,
                    country: null,
                    amount: null,
                    currency: null,
                    registrationId: '8ac9a4a26c471f88016c47eb722135a1',
                    shopperResultUrl: 'https://management.totalprocessing.com/server-to-server-registration'
                },
                channelOptions: [
                    { value: '8acda4c75e3caf20015e41168fdd11f6', text: 'pointsocial.co.uk - ST 3D ' }
                ],
                countryOptions: [
                    { value: 'AU', text: 'Australia' },
                    { value: 'CA', text: 'Canada' },
                    { value: 'CN', text: 'China' },
                    { value: 'FR', text: 'France' },
                    { value: 'DE', text: 'Germany' },
                    { value: 'IN', text: 'India' },
                    { value: 'JP', text: 'Japan' },
                    { value: 'SP', text: 'Spain' },
                    { value: 'GB', text: 'United Kingdom' },
                    { value: 'US', text: 'United States' }
                ],
                currencyOptions: [
                    { value: 'GBP', text: 'GBP' },
                    { value: 'EUR', text: 'EUR' },
                    { value: 'USD', text: 'USD' },
                    { value: 'AUD', text: 'AUD' },
                    { value: 'CAD', text: 'CAD' },
                    { value: 'NZD', text: 'NZD' },
                    { value: 'JPY', text: 'JPY' },
                    { value: 'HKD', text: 'HKD' },
                    { value: 'SGD', text: 'SGD' },
                    { value: 'MYR', text: 'MYR' },
                    { value: 'IDR', text: 'IDR' },
                    { value: 'THB', text: 'THB' },
                    { value: 'ARS', text: 'ARS' },
                    { value: 'AED', text: 'AED' },
                    { value: 'BRL', text: 'BRL' },
                    { value: 'INR', text: 'INR' }
                ],
                address: null,
                addresses: [],
                resourcePath: null,
                resourcePathTimer: null
            }
        },
        beforeMount() {
            this.getAddresses();
        },
        computed: {
            sortedCurrencies: function() {
                function compare(a, b) {
                    if (a.text < b.text)
                    return -1;
                    if (a.text > b.text)
                    return 1;
                    return 0;
                }
                return this.currencyOptions.sort(compare);
            },
        },
        methods: {
            getAddresses() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-addresses',
                data: { resourcePath: this.resourcePath },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.addresses = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            onSubmit(e) {
                e.preventDefault();

                if (this.$refs.form.validate()) {
                    axios({
                        method: 'post',
                        url: 'https://controlapi.totalprocessing.com/api/server-to-server-payment-registration',
                        data: { form: this.form },
                        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                        })
                        .then(response => {
                            console.log(response.data);
                            if(!("redirect" in response.data)) {
                                this.$swal({
                                    type: 'success',
                                    title: 'Successful Transaction',
                                    html: '<b>Result code:</b> ' + response.data.result.code + '<br/><br/> ' + response.data.result.description
                                })
                            }
                            else {
                                const iframe = document.getElementById('threeDsContainer');
                                const iframeData = "<form method='post' action='"+response.data.redirect.url+"' id='3ds-form' class='paymentWidgets'><input type='text' name='"+response.data.redirect.parameters[0].name+"' value='"+response.data.redirect.parameters[0].value+"'><input type='text' name='"+response.data.redirect.parameters[1].name+"' value='"+response.data.redirect.parameters[1].value+"'><input type='text' name='"+response.data.redirect.parameters[2].name+"' value='"+response.data.redirect.parameters[2].value+"'";

                                iframe.contentWindow.document.write(iframeData);
                                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                                iframeDoc.getElementById("3ds-form").submit();
                            }
                        })
                        .catch(e => {
                            this.errors.push(e)
                    })
                }
            },
            onReset(e) {
                this.$refs.form.reset();
            },
            addressOnChange(e) {

                if(e) {
                    this.address = this.addresses.find(x => x.address_name === e);
                    this.form.firstName = this.address.first_name;
                    this.form.surname = this.address.surname;
                    this.form.address1 = this.address.address_1;
                    this.form.address2 = this.address.address_2;
                    this.form.city = this.address.city;
                    this.form.postcode = this.address.postcode;
                    this.form.country = this.address.country;
                }
                else {
                    this.form.firstName = null;
                    this.form.surname = null;
                    this.form.address1 = null;
                    this.form.address2 = null;
                    this.form.city = null;
                    this.form.postcode = null;
                    this.form.country = null;
                }
            }
        }
    }
</script>

<style>
    #form-btns {
        margin-top: 1px;
    }

    #threeDsContainer {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
</style>